import React from "react";

interface IconProps {
  size?: number;
}

/**
 * Pickleball-merkki listariveille: maila ja pallo vektorina.
 *
 * Piirretty Spinloopin vareilla, koska Unicodessa ei ole pickleball-kuvaketta
 * eika kurkku-emoji (aiempi ratkaisu) lue kuvana. Vektori pysyy teravana
 * kaikilla naytoilla eika lataa mitaan.
 */
export function PickleballMark({ size = 18 }: IconProps) {
  return (
    <img
      src="/icons/mark-96.png"
      alt=""
      width={size}
      height={size}
      style={{ display: "inline-block", verticalAlign: "-3px", flexShrink: 0, borderRadius: size * 0.22 }}
      aria-hidden="true"
    />
  );
}

/**
 * Pickleball-pallo tekstin seassa: otsikot, napit, rivit.
 *
 * Korvaa 🎾-emojin, joka on tennispallo. Unicodessa ei ole pickleball-
 * emojia, joten sama kuva kuin tapahtumakortissa (/icons/pickleball.png).
 * Viesteissä (WhatsApp, sähköposti, push) kuvaa ei voi käyttää.
 */
export function PickleballBall({ size = 16 }: IconProps) {
  return (
    <img
      src="/icons/pickleball.png"
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      style={{ display: "inline-block", verticalAlign: "middle", objectFit: "contain", flexShrink: 0 }}
    />
  );
}

export function PickleballIcon({ size = 64 }: IconProps) {
  return (
    <img
      src="/icons/pickleball.png"
      alt="Pickleball"
      width={size}
      height={size}
      style={{ objectFit: "contain", display: "block" }}
    />
  );
}

export function TennisIcon({ size = 64 }: IconProps) {
  return (
    <img
      src="/icons/tennis.png"
      alt="Tennis"
      width={size}
      height={size}
      style={{ objectFit: "contain", display: "block" }}
    />
  );
}

export function PadelIcon({ size = 64 }: IconProps) {
  return (
    <img
      src="/icons/padel.png"
      alt="Padel"
      width={size}
      height={size}
      style={{ objectFit: "contain", display: "block" }}
    />
  );
}

/**
 * Tuomari: raitapaitainen figuuri pilli suussa.
 *
 * Korvasi oman SVG-siluetin. Unicodessa ei ole urheilutuomaria — lahin
 * on 🧑‍⚖️, joka on oikeussalin tuomari — ja siluetista puuttui se mika
 * tekee tuomarista tunnistettavan: pilli ja kasvot.
 *
 * Lahde oli 2048 px JPEG, jossa "lapinakyva" tausta oli piirretty
 * ruutukuvioksi, koska JPEG ei osaa alfaa. Tausta avattiin nurkista
 * floodfillilla, kuva rajattiin figuuriin ja skaalattiin 192 pikseliin.
 * Alkuperainen 1,4 MB tiedosto poistettiin: public/ menee sellaisenaan
 * hostingiin.
 */
export function RefereeMark({ size = 16 }: IconProps) {
  return (
    <img
      src="/icons/referee.png"
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      style={{ display: "inline-block", verticalAlign: "middle", objectFit: "contain", flexShrink: 0 }}
    />
  );
}

export function SportIcon({ gameType, size = 64 }: { gameType: string; size?: number }) {
  const t = (gameType || "").toLowerCase();
  if (t.includes("tennis")) return <TennisIcon size={size} />;
  if (t.includes("padel"))  return <PadelIcon size={size} />;
  return <PickleballIcon size={size} />;
}
